<template>
  <section>
    <report-filter-bar
      v-model="filter"
      :preset="preset"
      :busy="isAnyLoading"
      :compare-label="compareLabel"
      @preset="applyPreset"
      @change="refresh"
      @refresh="refresh"
    />

    <b-row class="match-height">
      <b-col
        cols="12"
        class="mb-1"
      >
        <report-chart
          :series="trend"
          title="درآمد خدمات"
          :subtitle="rangeLabel"
          :metrics="['revenue']"
          type="area"
          :height="300"
          :loading="loading('trend')"
          :skin="skin"
        />
      </b-col>
    </b-row>

    <b-row class="match-height">
      <b-col
        cols="12"
        class="mb-1"
      >
        <report-chart
          :series="trend"
          title="درخواست و پرداخت"
          subtitle="با خاموش‌کردن «فقط پرداخت‌شده» درخواست‌های بدون پرداخت هم دیده می‌شوند"
          :metrics="['requests', 'paid']"
          type="bar"
          :height="290"
          :loading="loading('trend')"
          :skin="skin"
        />
      </b-col>
    </b-row>

    <b-row>
      <b-col
        cols="12"
        class="mb-1"
      >
        <report-table
          :breakdown="byDuty"
          title="عملکرد هر خدمت"
          subtitle="«نرخ پرداخت» نسبت درخواست‌های پرداخت‌شده به کل درخواست‌های هر خدمت است"
          label-title="خدمت"
          show-image
          :loading="loading('byDuty')"
          :route-for="dutyRoute"
          empty-text="در این بازه درخواست خدمتی ثبت نشده است"
        />
      </b-col>
    </b-row>
  </section>
</template>

<script>
import reportMixin from '@core/mixins/report'

export default {
  name: 'ReportDuty',
  mixins: [reportMixin],
  data() {
    return {
      trend: null,
      byDuty: null,
    }
  },
  computed: {
    compareLabel() {
      return this.trend && this.trend.CompareRange ? this.trend.CompareRange.Label : null
    },
  },
  created() {
    this.refresh()
  },
  methods: {
    refresh() {
      this.fetchReport('trend', this.$api.report.dutyTrend)
      this.fetchReport('byDuty', this.$api.report.dutyByDuty)
    },

    dutyRoute(row) {
      return row.Id ? { name: 'updateduty', params: { id: row.Id } } : null
    },
  },
}
</script>
